export default {
    unMaskCep(value) {
        return value.replace(/\.|-/g, '')
    },
    unMaskCnpj(value) {
        return value.replace(/\.|\/|-/g, '')
    },
    unMaskPhone(value) {
        return value.replace(/\(|\)|-|\s/g, '')
    },
    unMaskCpf(value) {
        return value.replace(/\.|-/g, '')
    },
    unMaskCns(value) {
        return value.replace(/\s/g, '')
    },
    unMaskRg(value) {
        return value.replace(/\.|-/g, '')
    },
    unMaskNumeroCertidao(value) {
        return value.replace(/\s/g, '')
    },
    unMaskTemperaturaMMDG(value) {
        return parseFloat(value.replace(',', '.')).toFixed(2)
    },
    unMaskNumeroAutorizacaoFornecimento(value) {
        return value.replace(/\//g, '')
    },
    unMaskPlaca(value) {
        return value.replace('-', '')
    },
    unMaskDnv(value) {
        return value.replace(/-/g, '')
    },
}